// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
/* Store Custom Code
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
 */
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
// import AddToCartOptionsAndButton, {
//     AddToCartOptionsAndButtonStyles,
// } from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton"; // Store Custom Code
// import { productCardProps } from "@store/Themes/common/props/productCard"; // Store Custom Code
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
import ProductAddToListLink, { ProductAddToListLinkStyles } from "@store/Overrides/Components/ProductAddToListLink";
import { productCardProps } from "@store/Themes/common/props/productCard";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

interface OwnProps {
    showPrice: boolean;
    showAddToList: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss; // Starter Custom Code
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;
    // Starter Custom Code
    priceWrapper?: InjectableCss;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
}

export const actionsStyles: ProductListActionsStyles = {
    wrapper: productCardProps.actionsWrapper,
    priceWrapper: productCardProps.spacingWrapper,
    price: productCardProps.price,
    quantityBreakPricing: productCardProps.quantityBreakPricing,
    /* Store Custom Code - Start */
    addToCartOptionsAndButton: mergeProps(productCardProps.addToCartOptionsAndButton, {
        addToCartButton: {
            variant: "primary",
            css: css`
                ${x => x.theme.button.primary.css}
                width: 100%;
            `,
        },
    }),
    addToListWrapper: {
        css: css`
            position: absolute;
            top: ${pxToRem(20)};
            right: ${pxToRem(12)};
        `,
    },
    /* Store Custom Code - End */
    addToListLink: productCardProps.addToListLink,
};

const styles = actionsStyles;

const ProductListActions: FC<Props> = ({ productContext, productSettings, showPrice, showAddToList }) => {
    const canAddToList = showAddToList && productContext.product.canAddToWishlist; // Starter Custom Code

    return (
        <StyledWrapper {...styles.wrapper}>
            {/* Store Removed Code = ProductPrice */}
            <AddToCartOptionsAndButton
                /* Store Custom Code - Start */
                forCardView={true}
                productContext={productContext}
                productSettings={productSettings}
                /* Store Custom Code - End */
                extendedStyles={{
                    ...styles.addToCartOptionsAndButton,
                    unitOfMeasure: {
                        ...styles.addToCartOptionsAndButton?.unitOfMeasure,
                        uid: `uom-${productContext.product.id}`,
                    },
                    quantityOrdered: {
                        ...styles.addToCartOptionsAndButton?.quantityOrdered,
                        id: `qty-ordered-${productContext.product.id}`,
                    },
                    addToCartButton: {
                        ...styles.addToCartOptionsAndButton?.addToCartButton,
                        "data-test-selector": `actionsAddToCart${productContext.product.id}`,
                    },
                }}
            />
            {canAddToList /* Starter Custom Code */ && (
                <StyledWrapper {...styles.addToListWrapper}>
                    <ProductAddToListLink
                        data-test-selector={`actionsAddToList${productContext.product.id}`}
                        // Store Removed - extendedStyles
                        // Store Custom Code
                        showTitle={true}
                        showIcon={true}
                    />
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductListActions));
